import DoctorConfirmationAlarmDisclaimer from './components/AlarmDisclaimer';
import DoctorConfirmationCheckout from './components/Checkout/CheckoutForm';
import DoctorConfirmationConfirmation from './components/Confirmation';
import DoctorConfirmationContact from './components/Contact';
import DoctorConfirmationDisclaimer from './components/Disclaimer';
import DoctorConfirmationIntro from './components/Intro';

export const DOCTOR_CONFIRMATION_QUESTIONS = [
  {
    Component: DoctorConfirmationAlarmDisclaimer,
    alarmOnly: true,
  },
  {
    Component: DoctorConfirmationIntro,
    isIntro: true,
  },
  {
    Component: DoctorConfirmationDisclaimer,
  },
  {
    Component: DoctorConfirmationContact,
  },
  {
    Component: DoctorConfirmationCheckout,
    submitButtonText: () => 'Submit',
    shouldSubmit: true,
  },
  {
    Component: DoctorConfirmationConfirmation,
    submitButtonText: () => 'Done',
    hideBackButton: true,
  },
];
